import { Container } from '@mui/material';
import React from 'react';
import Header from '../components/common/Header';
import IntroCard from '../components/Cards/IntroCard';
import '../Style/Theme/index.css';

import GstForm from '../components/Forms/GstForm';
export default function GstNumber() {
  return (
    <>
      <Container maxWidth={false} className="container_Th">
        <Header showBar={true} step={4} />
        <IntroCard
          title="Select GST number"
          subtitle="We found these active GST numbers linked with your PAN card. Choose one to proceed."
          img="/assets/gst.svg"
        />
        <GstForm />
      </Container>
    </>
  );
}
